var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Health_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Health_",
    "data-name": "Health ",
    clipPath: "url(#clip-Health_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818",
    transform: "translate(-542 1209)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(542 -1209)",
    className: "icon-background"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-heartbeat",
    "data-name": "Icon awesome-heartbeat",
    d: "M19.361,15.056l-3.005,6.01a.967.967,0,0,1-1.747-.036l-3.441-7.637L9.354,17.729H3.664L14.7,29.006a1.077,1.077,0,0,0,1.554,0L27.294,17.729H20.7ZM28.643,4.783,28.5,4.632a7.921,7.921,0,0,0-11.331,0L15.479,6.361,13.792,4.638a7.911,7.911,0,0,0-11.331,0l-.145.145a8.3,8.3,0,0,0-.441,11.011H8.066l2.171-5.212a.969.969,0,0,1,1.778-.024l3.519,7.818,2.963-5.92a.966.966,0,0,1,1.729,0l1.669,3.338h7.189a8.3,8.3,0,0,0-.441-11.011Z",
    transform: "translate(550.339 -1199.428)",
    className: "icon-foreground"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentHealth);
export default __webpack_public_path__ + "static/media/studentHealth.1bc29fa862c120b358a41ad71f27c626.svg";
export { ForwardRef as ReactComponent };